export default __webpack_public_path__ + "assets/ogg/d62b64135fc103a27caa2f18d5361b34.ogg";